<template>
    <div>
        <div class="my-3">
            <p class="category-title mx-3 mb-3">{{worksheet.name}}</p>
            <div class="row m-0 align-items-start">
                <div class="col-8 mb-3">
                    <Card class="p-4">
                        <p class="my-1 sub-heading">Description</p>
                        <div class="my-1 sub-text" v-html="worksheet.description"></div>

                        <div class="mt-4">
                            <p class="my-3 sub-heading">Training Content</p>
                            <div v-for="(day, ind) in worksheet.worksheet" :key="ind">
                                <div class="task-detail-module-identifier my-3 d-flex justify-content-between">
                                    <div>
                                        <font-awesome-icon icon="fa-solid fa-cube" /> DAY {{ ind + 1 }} -
                                        {{ day.status.replaceAll('_', ' ') }}
                                    </div>
                                    <div class="task-due-date">Due Date: {{ formatDate(day.taskList[0].endDate) }}</div>
                                </div>
                                <div class="timeline-box">
                                    <WorkSheetTaskListComponent
                                        :dayTask="dayTask"
                                        :day="day"
                                        v-for="(dayTask, index) in day.taskList"
                                        :index="ind"
                                        :temp="index"
                                        :key="dayTask.task.id"
                                        @completeTask="handlerTaskCompletion"
                                    />
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
                <div class="col-4 fixed-col">
                    <Card class="p-3 gap-3 m-0">
                        <img :src="worksheet.trainingImg" v-if="worksheet.trainingImg" class="course-img" />
                        <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU"
                            v-else
                            class="course-img"
                        />
                        <!-- 1280 x 720 -->
                        <div class="d-flex flex-column justify-content-start">
                            <p class="mt-3 mb-2 course-title">{{ worksheet.name }}</p>
                            <!-- <p class="m-0 sub-heading">Duration: 2h</p> -->
                            <!-- <Badge
                class="badge-rounded badge-rounded-grey-outline my-2"
                :label="'Trainer : ' + worksheet.trainer.name"
              /> -->
                            <div class="d-flex">
                                <div class="chart-area">
                                    <ApexChart
                                        :options="chartOptions"
                                        :series="getPercentage(progress.totalNoOfTasks, progress.completedTasks)"
                                    />
                                </div>
                                <div class="d-flex flex-column">
                                    <Badge
                                        class="badge-rounded badge-rounded-grey-outline my-1"
                                        :label="'Total Tasks: ' + progress.totalNoOfTasks"
                                    />
                                    <Badge
                                        class="badge-rounded badge-rounded-grey-outline my-1"
                                        :label="'Completed Tasks: ' + progress.completedTasks"
                                    />
                                    <Badge
                                        class="badge-rounded badge-rounded-grey-outline my-1"
                                        :label="'Total Days: ' + progress.totalNoOfDays"
                                    />
                                    <Badge
                                        class="badge-rounded badge-rounded-grey-outline my-1"
                                        :label="'Completed Days: ' + progress.completedDays"
                                    />
                                </div>
                            </div>
                            <p class="footer-text mt-3 mb-0">Started on: {{ formatDate(worksheet.startDate) }}</p>
                        </div>
                    </Card>
                </div>
            </div>
        </div>

        <!-- <div class="chat-box"> -->
        <beautiful-chat
            :participants="[]"
            :onMessageWasSent="handleSentMessage"
            :messageList="commentsForSelectedWorksheet"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="false"
            :showFile="false"
            :showEdition="false"
            :showDeletion="false"
            :showTypingIndicator="showTypingIndicator"
            :showLauncher="true"
            :showCloseButton="true"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            @onType="handleOnType"
            @edit="editMessage"
            id="chat-box"
        />
        <!-- </div> -->
    </div>
</template>

<script>
import Vue from 'vue';
import CloseIcon from '../assets/image/close.png';
// import Button from "../components/ButtonComponent.vue";
import Badge from '../components/BadgeComponent.vue';
import Card from '../components/CardComponent.vue';
import WorkSheetTaskListComponent from '../components/WorkSheetTaskListComponent.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapGetters: workSheetMapGetters, mapActions: workSheetMapActions } = createNamespacedHelpers('WorkSheet');
const { mapGetters: userMapGetters, mapActions: mapUserActions } = createNamespacedHelpers('User');
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers('Training');
const { mapGetters: authMapGetters } = createNamespacedHelpers('Auth');

export default {
    name: 'WorksheetPage',
    data() {
        return {
            initOpen: false,
            toggledOpen: false,
            chartOptions: {
                chart: {
                    height: 10,
                    width: 10,
                    type: 'radialBar',
                    toolbar: {
                        show: true,
                    },
                },
                plotOptions: {
                    radialBar: {
                        startAngle: 0,
                        endAngle: 360,
                        hollow: {
                            margin: 0,
                            size: '70%',
                            background: '#ffffff',
                            image: undefined,
                            imageOffsetX: 0,
                            imageOffsetY: 0,
                            position: 'front',
                        },
                        track: {
                            background: '#f3f3f3',
                            strokeWidth: '80%',
                            margin: 0,
                        },

                        dataLabels: {
                            show: true,
                            name: {
                                offsetY: -5,
                                show: true,
                                color: '#888',
                                fontSize: '10px',
                            },
                            value: {
                                formatter: function (val) {
                                    return val + '%';
                                },
                                offsetY: 3,
                                color: '#000',
                                fontSize: '12px',
                                show: true,
                            },
                        },
                    },
                },
                fill: {
                    type: ['solid'],
                    colors: ['#1da8d5'],
                },
                stroke: {
                    lineCap: 'round',
                },
                labels: ['Progress'],
                fontSize: '10px',
            },
            icons: {
                open: {
                    img: 'https://icon-library.com/images/chat-icon-white/chat-icon-white-28.jpg',
                    name: 'default',
                },
                close: {
                    img: CloseIcon,
                    name: 'default',
                },
                file: {
                    // img: FileIcon,
                    name: 'default',
                },
                closeSvg: {
                    img: CloseIcon,
                    name: 'X',
                },
            },

            newMessagesCount: 0,
            isChatOpen: false, // to determine whether the chat window should be open or closed
            showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
            colors: {
                header: {
                    bg: '#1DA8D5',
                    text: '#ffffff',
                },
                launcher: {
                    bg: '#1DA8D5',
                },
                messageList: {
                    bg: '#ffffff',
                },
                sentMessage: {
                    bg: '#1DA8D5',
                    text: '#ffffff',
                },
                receivedMessage: {
                    bg: '#eaeaea',
                    text: '#222222',
                },
                userInput: {
                    bg: '#f4f7f9',
                    text: '#565867',
                },
            }, // specifies the color scheme for the component
            alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
            messageStyling: true,
        };
    },
    components: {
        Card,
        Badge,
        // Button,
        // Chat,
        WorkSheetTaskListComponent,
    },
    computed: {
        ...workSheetMapGetters({
            worksheet: 'getWorkSheet',
        }),
        ...userMapGetters({
            progress: 'getProgress',
        }),
        ...authMapGetters({
            user: 'getUser',
        }),
        ...trainingMapGetters({
            commentsForSelectedWorksheet: 'getCommentsForSelectedWorkSheetInChat',
        }),
    },
    methods: {
        ...mapUserActions({
            updateTaskCompletion: 'UPDATE_TASK_STATUS',
            getWorkSheetProgressById: 'GET_PROGRESS_BY_ID',
        }),
        ...workSheetMapActions({
            getWorkSheetDetails: 'GET_WORKSHEET_BY_ID',
            createNewComment: 'CREATE_COMMENT_FOR_WORKSHEET',
        }),
        ...trainingMapActions({
            getCommentsByWorksheetId: 'GET_COMMENTS_BY_WORKSHEET_ID',
        }),

        getPercentage(totalTask, completedTask) {
            return [
                isNaN(Number(Math.round((completedTask / totalTask) * 100)))
                    ? 0
                    : Number(Math.round((completedTask / totalTask) * 100)),
            ];
        },
        handleSentMessage(message) {
            if (message.data.text.length > 0 && message.data.text.trim().length > 0) {
                // this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1;
                // this.onMessageWasSent({ author: "support", type: "text", data: { text } });

                const payload = {
                    comment: message.data.text,
                    userId: this.user.userId,
                    worksheetId: this.$route.params.id,
                };


                this.createNewComment({
                    payload,
                    successCallback: ({ data }) => {
                        if (data.status === 'OK') {
                            Vue.$toast.success('Comment Posted Successfully');
                            this.getCommentsByWorksheetId(this.$route.params.id);
                        } else {
                            Vue.$toast.error('Something went wrong');
                        }
                    },
                    errorCallback: (err) => {
                        Vue.$toast.error(err.message);
                    },
                });
                this.message = '';
            }
        },
        handleToggleOpen(open) {
            this.toggledOpen = open;
        },
        handlerTaskCompletion(data) {
            console.log(data)
            let taskData = {
                day: data.day.day,
                // link: data.submissionLink,
                status: !data.dayTask.status,
                taskId: data.dayTask.task.id,
                id: this.worksheet.id,
                userId: this.user.userId,
                userType:'U'
            };
            if(data.submissionLink){
            taskData={...taskData,link:data.submissionLink}
            }
            this.updateTaskCompletion({
                taskData,
                successcallback: ({ data }) => {
                    if (data.status === 'OK') {
                        this.getWorkSheetDetails(this.$route.params.id);
                        this.getWorkSheetProgressById(this.$route.params.id);
                        Vue.$toast.success('Task Submitted successfully');
                    } else {
                        Vue.$toast.error('Task Updation Failed');
                    }
                },
                errorcallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
        },
        // Chat method

        onMessageWasSent(message) {
            // called when the user sends a message
            this.messageList = [...this.messageList, message];
        },
        openChat() {
            // called when the user clicks on the fab button to open the chat
            this.isChatOpen = true;
            this.newMessagesCount = 0;
        },
        closeChat() {
            // called when the user clicks on the botton to close the chat
            this.isChatOpen = false;
        },
        handleScrollToTop() {
            // called when the user scrolls message list to top
            // leverage pagination for loading another page of messages
        },
        handleOnType() {
            console.log('Emit typing event');
            console.clear();
        },
        editMessage(message) {
            const m = this.messageList.find((m) => m.id === message.id);
            m.isEdited = true;
            m.data.text = message.data.text;
        },
        askConfirmation() {
            alert('Are you sure you want to leave?');
        },
    },
    // mounted() {
    //   // this.$nextTick(function () {
    //   window.addEventListener("beforeunload", this.askConfirmation);
    //   // });
    // },
    // beforeDestroy() {
    //   window.removeEventListener("beforeunload", this.askConfirmation);
    // },
    created() {
        this.getWorkSheetDetails(this.$route.params.id);
        this.getWorkSheetProgressById(this.$route.params.id);
        this.getCommentsByWorksheetId(this.$route.params.id);
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.fa-users-rectangle {
    font-size: 30px;
    margin: auto;
}
.category-title {
    font-size: $font-size-xxl;
    font-weight: $font-weight-bold;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}
.course-title {
    font-size: $font-size-xxl;
    font-weight: $font-weight-normal-2;
    color: $light-600;
}
.catalogue-card {
    border-radius: $field-border-radius;
    border: 1px solid $light-300;
}
.course-img {
    border-radius: $field-border-radius;
    background-color: $light-300;
    width: 100%;
}

.sub-heading {
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
    color: $light-500;
}

#chat-box {
    z-index: 999 !important;
}

.timeline-box {
    border-left: 1px solid $dark-200;
    padding-left: 10px;
    margin-left: 10px;
}

.task-detail-module-identifier {
    font-size: $font-size-sm;
    color: $light-600;
    font-weight: $font-weight-bold;
    margin: 0px;
    text-transform: uppercase;
    letter-spacing: 1px;
}
.task-due-date {
    font-size: $font-size-sm;
    color: $light-600;
    font-weight: $font-weight-bold;
    text-transform: none;
    letter-spacing: 0px;
}
.task-due-date-fade {
    font-size: $font-size-sm;
    color: $light-600;
    text-transform: none;
    letter-spacing: 0px;
}
.sub-text {
    font-size: $font-size-lg;
    font-weight: $font-weight-normal-2;
    color: $light-600;
}

.footer-text {
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-2;
    color: $light-500;
}

.fixed-col {
    position: sticky;
    top: 10%;
    z-index: 0;
}
.chart-area {
    width: 160px;
    height: 120px;
}
</style>
